import axios from "axios";

import { APIImpresion } from "../Constants/ApiConnection";

const buildUrl = (baseUrl, path) => {
  if (!baseUrl) {
    throw new Error("No esta configurada la variable API_IMPRESION_URL.");
  }

  return `${baseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
};

export const generarPdfEstadoDeCuentaVn = async (values) => {
  const url = buildUrl(APIImpresion, "/estadocuentavn");

  return axios.post(url, values, {
    responseType: "blob",
    headers: {
      Accept: "application/pdf",
      "Content-Type": "application/json",
    },
  });
};

export const quitarTablaAmortizacion = (values) => {
  if (Array.isArray(values)) {
    return values.map((value) => quitarTablaAmortizacion(value));
  }

  if (values && typeof values === "object") {
    return Object.entries(values).reduce((acc, [key, value]) => {
      if (key !== "tabla_amortizacion") {
        acc[key] = quitarTablaAmortizacion(value);
      }

      return acc;
    }, {});
  }

  return values;
};

export const abrirPdfEnNavegador = (pdfResponse, targetWindow = null) => {
  const pdfBlob = new Blob([pdfResponse.data], {
    type: pdfResponse.headers?.["content-type"] || "application/pdf",
  });
  const pdfUrl = window.URL.createObjectURL(pdfBlob);

  if (targetWindow) {
    targetWindow.location.href = pdfUrl;
  } else {
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  }

  window.setTimeout(() => {
    window.URL.revokeObjectURL(pdfUrl);
  }, 60000);
};
